import { utils } from "../../core/helpers/utils";
import { authHelpers } from "../helpers/auth";

export const authService = {
  login,
  register,
  logout,
  setupPassword,
};

function login(email, password) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    },
    credentials: "include",

    body: utils.getPKey()
      ? new URLSearchParams({
        payload: utils.encryptedPayload({
          "email": email,
          "password": password,
          "isAjax": true,
          "Platform": "web",
          "source": "iosApp",
        })
      })
      : "email=" +
      encodeURIComponent(email) +
      "&password=" +
      encodeURIComponent(password) +
      "&isAjax=true&Platform=web&source=iosApp",
  };

  return fetch(process.env.REACT_APP_API_URL + "/auth/login", requestOptions)
    .then((response) => response.json())
    .then((result) => {
      let authResponse = utils.parsePayload(result);;

      if (!authResponse.success || authResponse.message !== 1) {
        //Set error state and handle it
        var error = authHelpers.getLoginError(authResponse.message);
        error["success"] = false;
        return error;
      }

      //Set the auth cookie
      authHelpers.setAuthCookie(true, 1);
      //Return success.
      return {
        success: true,
        message: "Login successful!",
      };
    });
}

function register(name, email, password, repassword, phone) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    },
    body: new URLSearchParams({
      name: name,
      email: email,
      password: password,
      repassword: repassword,
      phone: phone,
      isAjax: true,
    }).toString(),
  };

  return fetch(process.env.REACT_APP_API_URL + "/auth/register", requestOptions)
    .then((response) => response.json())
    .then((authResponse) => {
      if (!authResponse.success || authResponse.message !== 1) {
        //Set error state and handle it
        var error = authHelpers.getSignupError(authResponse.message);
        error["success"] = false;
        return error;
      }

      return {
        success: true,
        message: "Registration successful!",
      };
    });
}

function logout(isFromMf) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    },
    credentials: "include",
  };

  return fetch(process.env.REACT_APP_API_URL + "/auth/logout", requestOptions)
    .then((response) => response.json())
    .then((result) => {
      const authResponse = utils.parsePayload(result);

      if (authResponse.errCode === 1) {
        authHelpers.logout("show", isFromMf);
        return {
          message: `Unable to logout. Please try again later`,
        };
      } else {
        authHelpers.logout("", isFromMf);
        return {
          success: true,
          message: "Logout successful!",
        };
      }
    })
    .catch((error) => {
      return {
        message: `Unable to logout. Please try again later`,
      };
    });
}

function setupPassword(password, repassword) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    },
    credentials: "include",
    body: new URLSearchParams({
      password: password,
      repassword: repassword
    }).toString(),
    /* body:
      "password=" +
      encodeURIComponent(password) +
      "&repassword=" +
      encodeURIComponent(repassword), */
  };
  return fetch(
    process.env.REACT_APP_API_URL + "/users/changePassword",
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      const setupResponse = utils.parsePayload(result);

      if (!setupResponse || !setupResponse.success) {
        return {
          success: false,
          message:
            setupResponse.error || "Unable to proceed. Please try again later.",
        };
      } else {
        return {
          success: setupResponse.success,
          data: setupResponse.data ? setupResponse.data.nextPage : null
        };
      }
    });
}
